import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const AssigneeFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.ASSIGNEE}
        filterName={FilterName.ASSIGNEE}
        valueKey="assignees"
        isNested={isNested}
      />
    )
  },
)
